<template>
  <div style="display: inline;">
    <yi_tabs :tabs="[{ title: 'gailan', cache: true }, { title: 'mingxi', cache: false }]">
      <template #gailan style="height: 100%">
        <overview @setParam="setParam" ref="overview"></overview>
      </template>
      <template #mingxi>
        <detail :formData="formData"  ref="detail"></detail>
      </template>
    </yi_tabs>
  </div>
</template>

<script type="text/javascript">
import overview from '@@/pages/web/report/inspection_report/overview';
import detail from '@@/pages/web/report/inspection_report/detail';
export default {
  name: 'web_report_inspection_report_list',
  components: {
    overview,
    detail
  },
  data() {
    return {
      contentHeight: 0,
      formData:{},
    }
  },
  mounted() {

  },
  created() {},
  methods: {

    setParam(formData){
      this.formData = formData;
    },
  }
}
</script>

<style scoped lang="scss">

</style>